import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    inventionMembers: [],
    employees: [],
    roles: [],
  },
  getters: {
    inventionMembers: state => state.inventionMembers,
    employees: state => state.employees,
  },
  mutations: {
    SET_INVENTION_MEMBERS: (state, data) => { state.inventionMembers = data },
    SET_EMPLOYEES: (state, data) => { state.employees = data },
  },
  actions: {
    async createInventionMember({ commit }, params) {
      try {
        const response = await axios.post('uni/researchInventionMembers', params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getInventionMembers({ commit }, params) {
      try {
        const response = await axios.get('uni/researchInventionMembers', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          commit('SET_INVENTION_MEMBERS', records)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async updateInventionMember({ commit }, params) {
      try {
        const response = await axios.put(`uni/researchInventionMembers/${params.id}`, params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteInventionMember({ commit }, id) {
      try {
        const response = await axios.delete(`uni/researchInventionMembers/${id}`)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getEmployeesByOrganizationId({ commit }) {
      try {
        const response = await axios.get('uni/employees/getAllByOrganizationId')
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_EMPLOYEES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
